// this is an autogenerated file from App/Account/Content/Orders/Filters/StatusChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Orders_Filters_StatusChooser{
  orders_order_statuses(order_by: [{ value: asc }]) {
    id: value
    text: comment
  }
}

`